
import api from '../src/services/labourPalnningService';
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const ProductionMixin = {
    data() {
        return {
            moment: moment,
            old_setup_record: {},
            active_tab_link: 'production',
            location: '',
            selected_location: '',
            selected_date: '',
            location_list: [],
            selected_production: '',
            production_list: [],
            selected_category: '',
            category_list: [],
            search: '',
            production_header: [],
            production_data: [],
            store_production_setup_data: [],
            production_stations: [],
            dummy_data: {
                "production_station_id": null,
                "article_id": null,
                "holding_time": null,
                "max_quantity_per_tray": null,
                "number_of_slots": null
            },
            store_articles: [],
            add_new_prod_setup: false,
            selected_article_id: '',
            selected_holding_time: '',
            selected_tray: '',
            selected_slots: '',
            holding_time_slot: [],
            pickerOptions: {
                selectableRange: '00:00:00 - 23:59:00', // Limit duration up to 4 hours
                format: 'HH:mm',
                steps: ['00', '10', '20', '30', '40', '50'] // 10-minute intervals
            },
            selected_production_station: '',
            setup_tbl_loading: false,
            production_segments: [],
            forecast_tbl_loading: false,
            all_query_data: [],
            search_data: '',
            editable_record_data: {},
            forecast_qty_data: [],
            next_update_remaining_time: '',
            is_speech_playing: false,
            is_add_new_station_mode: false,
            station_loading: false,
            is_station_active: false,
            number_of_stations: null,
            production_station_id: null,
            add_prod_station_popup: false,
            production_station_list: [],
            day_parts_data: [],
            selected_day_parts: [],
            filter_production_station: [],
            filter_article: [],
            day_part_colors: [
                '#E3F2FD',  // Light Blue
                '#FFEBEE',  // Light Red
                '#E8F5E9',  // Light Green
                '#FFF3E0',  // Light Orange
                '#EDE7F6',  // Light Purple
                '#F3E5F5',  // Light Pink
                '#E0F7FA',  // Light Cyan
                '#FFFDE7',  // Light Yellow
                '#F1F8E9',  // Light Lime
                '#FBE9E7'   // Light Coral
            ],
            search_prod_station: '',
        }
    },
    computed: {
        customFormat() {
            return 'HH:mm'; // Display only hours and minutes in the input
        },
        productionSetupData() {
            let data = [];
            if (this.store_production_setup_data.length) {
                this.store_production_setup_data.forEach(e => {
                    let temp = {};
                    temp.id = e.id;
                    temp.article_id = e.article_id;
                    temp.production_station_id = e.production_station_id;
                    temp.time = moment(e.holding_time, 'HH:mm:ss').format();
                    // const article = this.store_articles.find(a => a.id == e.article_id);
                    const station = this.production_stations.find(s => s.id == e.production_station_id);
                    temp.article = e.article_name || '-';
                    temp.holding_time = e.holding_time;
                    temp.max_quantity_per_tray = e.max_quantity_per_tray;
                    temp.number_of_slots = e.number_of_slots;
                    temp.production_station = station && station.name;
                    temp.is_editable = false;
                    data.push(temp);
                });
            }
            // Search data
            if (this.search_data && this.active_tab_link == 'setup') {
                data = data.filter(e => {
                    if (e.article.toLowerCase().includes(this.search_data.toLowerCase())) {
                        return e;
                    }
                });
            }
            // Filter by filter_production_station 
            if (this.filter_production_station.length) {
                data = data.filter(e => {
                    if (this.filter_production_station.includes(e.production_station_id)) {
                        return e;
                    }
                });
            }
            // Filter by filter_article
            if (this.filter_article.length) {
                data = data.filter(e => {
                    if (this.filter_article.includes(e.article_id)) {
                        return e;
                    }
                });
            }
            // sort data according to article name
            data.sort((a, b) => {
                return a.article.localeCompare(b.article);
            });
            return data;
        },
        computedProductionData() {
            let data = [...this.production_data];
            if (this.search_data && this.active_tab_link == 'production') {
                data = data.filter(e => {
                    if (e.article_name.toLowerCase().includes(this.search_data.toLowerCase())) {
                        return e;
                    }
                });
            }
            //  sort data according to article name
            data.sort((a, b) => {
                return a.article_name.localeCompare(b.article_name);
            });
            return data;
        },
        computedArticles() {
            let data = [...this.store_articles];
            // If articles is already added in production setup then add is_added key in it
            if (this.store_production_setup_data.length) {
                data.forEach(e => {
                    const article = this.store_production_setup_data.find(a => a.article_id == e.id);
                    if (article) {
                        e.is_added = true;
                    }
                });
            }
            //  sort data according to article name
            data.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            return data;
        },
        computedDayPartHeader() {
            if(!this.day_parts_data.length) {
                 return [];
            }
            let parts = [...this.day_parts_data];
            let header = [...this.production_header];
            
            let result = [];
            let startHour = moment(parts[0].time, 'HH:mm');
            let endHour = moment(parts[parts.length-1].time, 'HH:mm');
        
            // Sort the parts according to start_time
            parts.sort((a, b) => {
                return moment(a.start_time, 'HH:mm') - moment(b.start_time, 'HH:mm');
            });
        
            parts.forEach((e, i) => {
                const header_count = header.filter(h => h.day_part == e.day_part_name).length;
                result.push({
                    day_part_name: e.day_part_name,
                    day_part_color: e.day_part_color,
                    colSpan: header_count,
                    rowSpan: 1,
                    start_time: moment(e.start_time, 'HH:mm'),
                    end_time: moment(e.end_time, 'HH:mm'),
                    day_part_id: e.id
                });
            });
            
        
            // Add dummy data for any missing times
            for (let i = 0; i < result.length - 1; i++) {
                let currentEnd = result[i].end_time;
                let nextStart = result[i + 1].start_time;
        
                if (currentEnd < nextStart) {
                    result.splice(i + 1, 0, {
                        day_part_name: 'DUMMY',
                        day_part_color: 'gray',
                        colSpan: 0,
                        rowSpan: 1,
                        start_time: currentEnd,
                        end_time: nextStart
                    });
                }
            }
        
            // Handle the case where the first entry does not start at the beginning of the day
            if (result.length > 0 && result[0].start_time > startHour) {
                result.unshift({
                    day_part_name: 'DUMMY',
                    day_part_color: 'gray',
                    colSpan: 0,
                    rowSpan: 1,
                    start_time: startHour,
                    end_time: result[0].start_time
                });
            }
        
            // Handle the case where the last entry does not end at the end of the day
            if (result.length > 0 && result[result.length - 1].end_time < endHour) {
                result.push({
                    day_part_name: 'DUMMY',
                    day_part_color: 'gray',
                    colSpan: 0,
                    rowSpan: 1,
                    start_time: result[result.length - 1].end_time,
                    end_time: endHour
                });
            }
        
            // Convert the moment objects back to strings
            result.forEach(r => {
                r.start_time = r.start_time.format('HH:mm');
                r.end_time = r.end_time.format('HH:mm');
            });

            // Filter according to selected_day_parts
            if (this.selected_day_parts.length) {
                result = result.filter(e => {
                    if (this.selected_day_parts.includes(e.day_part_id)) {
                        return e;
                    }
                });
            }

            // If colspan is 0 then remove that element
            result = result.filter(e => e.colSpan != 0);
        
            return result;
        },
        computedSearchProdStation(){
            let result = [...this.production_station_list];
            if (this.search_prod_station) {
                result = result.filter(e => {
                    if (e.name.toLowerCase().includes(this.search_prod_station.toLowerCase())) {
                        return e;
                    }
                });
            }
            return result;
        },
        computedProdHeader(){
            let result = [...this.production_header];
            // Filter according to selected_day_parts
            if (this.selected_day_parts.length) {
                result = result.filter(e => {
                    if (this.selected_day_parts.includes(e.day_part_id)) {
                        return e;
                    }
                });
            }
            return result;
        },
        computedProdStation(){
            let prod_station = [...this.production_stations];
            return prod_station.filter(e => e.active);
        }
    },
    methods: {
        setActiveTabLink(tab_link) {
            this.active_tab_link = tab_link;
            this.search_data = '';
        },
        getDayPartData(){
            api.getDayParts().then(res => {
                this.day_parts_data = JSON.parse(res.data);
                this.day_parts_data.forEach((r, index)=>{
                    r.day_part_color = this.day_part_colors[index];
                })
            }).catch((error) => {
                console.log(error);
            });
        },
        changeDayParts(){

        },
        handleNewStationMode(){
            this.is_add_new_station_mode = !this.is_add_new_station_mode;
        },
        runAtEveryDynamicInterval(intervalInMinutes) {
            this.updateRemainingTime(intervalInMinutes);
            const now = new Date();
            const minutes = now.getMinutes();
            const currentSeconds = now.getSeconds();

            // Calculate the time remaining until the next interval
            const remainingMinutes = intervalInMinutes - (minutes % intervalInMinutes);
            const remainingSeconds = 60 - currentSeconds;
            const millisecondsToNextInterval = remainingMinutes * 60 * 1000 + remainingSeconds * 1000;
            console.log(remainingMinutes, millisecondsToNextInterval, 'millisecondsToNextInterval');
            const self = this;

            setInterval(function () {
                self.updateRemainingTime(intervalInMinutes);
            }, 1000);

            // Set the interval to run the function at the next dynamic interval
            setTimeout(function () {
                // Perform your desired task here
                console.log('Task performed at:', new Date());

                const now = new Date();
                let nextHour = now.getHours() + 1;
                // Reset the extra minutes to 00 if it's already passed the upcoming hour
                if (nextHour >= 24) {
                  nextHour = 0;
                }
                // Set the next hour time without extra minutes
                const nextTime = new Date(now);
                nextTime.setHours(nextHour, 0, 0, 0);

                self.getVcmsForecastData({ check: 'call_speech_data', time: nextTime });

                // Call the function again after the dynamic interval
                self.runAtEveryDynamicInterval(intervalInMinutes);
            }, millisecondsToNextInterval);
        },          
        runAtEvery30Minutes() {
            this.updateRemainingTime(30);
            const now = new Date();
            const minutes = now.getMinutes();
            const currentSeconds = now.getSeconds();

            // Calculate the time remaining until the next 30-minute interval
            const remainingMinutes = 30 - (minutes % 30);
            const remainingSeconds = 60 - currentSeconds;
            const millisecondsToNextInterval = remainingMinutes * 60 * 1000 + remainingSeconds * 1000;
            console.log(remainingMinutes, millisecondsToNextInterval, 'millisecondsToNextInterval');
            const self = this;
            setInterval(function() {
                self.updateRemainingTime(30);
              }, 1000);
            // Set the interval to run the function at the next 30-minute interval
            setTimeout(function () {
                // Perform your desired task here
                console.log('Task performed at:', new Date());
                const now = new Date();
                let nextHour = now.getHours() + 1;
                // Reset the extra minutes to 00 if it's already passed the upcoming hour
                if (nextHour >= 24) {
                  nextHour = 0;
                }
                // Set the next hour time without extra minutes
                const nextTime = new Date(now);
                nextTime.setHours(nextHour, 0, 0, 0);

                self.getVcmsForecastData({check: 'call_speech_data', time: nextTime});
                // Call the function again after 30 minutes
                self.runAtEvery30Minutes();
            }, millisecondsToNextInterval);
        },
        updateRemainingTime(intervalInMinutes) {
            const now = new Date();
            const minutes = now.getMinutes();
            const seconds = now.getSeconds();

            // Calculate the time remaining until the next interval
            const remainingMinutes = intervalInMinutes - (minutes % intervalInMinutes);
            const remainingSeconds = 60 - seconds;

            // Calculate the total remaining seconds
            const totalRemainingSeconds = remainingMinutes * 60 + remainingSeconds;

            // Convert remaining seconds to HH:MM:SS format
            const remainingHours = Math.floor(totalRemainingSeconds / 3600);
            const remainingMins = Math.floor((totalRemainingSeconds % 3600) / 60);
            const remainingSecs = totalRemainingSeconds % 60;

            // Format the remaining time as HH:MM:SS
            const formattedRemainingTime = `${String(remainingHours).padStart(2, '0')}:${String(remainingMins).padStart(2, '0')}:${String(remainingSecs).padStart(2, '0')}`;

            // Update the UI or store the remaining time as needed
            this.next_update_remaining_time = formattedRemainingTime;
            // document.getElementById('remainingTime').innerText = `Remaining Time: ${formattedRemainingTime}`;
        },    
        playSpeech(){
            this.is_speech_playing = true;
            const now = new Date();
            let nextHour = now.getHours() + 1;
            // Reset the extra minutes to 00 if it's already passed the upcoming hour
            if (nextHour >= 24) {
                nextHour = 0;
            }
            // Set the next hour time without extra minutes
            const nextTime = new Date(now);
            nextTime.setHours(nextHour, 0, 0, 0);
            const actual_datetime = moment(this.selected_date).format('YYYY-MM-DD') + 'T' + moment(nextTime).format('HH:mm:ss');
            this.speechProductInfo(actual_datetime);
        },
        pauseSpeech(){
            this.is_speech_playing = false;
            window.speechSynthesis.cancel();
        },
        speechProductInfo(actual_datetime){
            return;
            let data = [...this.production_data];
            
            data.sort((a, b) => {
                return a.article_name.localeCompare(b.article_name);
            });

            let speechCounter = 0;
            data.forEach((e) => {
                const qty = this.getProdSetupDataByDateKey('quantity', e.article_id, actual_datetime);
                const no_of_trays = this.getProdSetupDataByDateKey('number_of_trays', e.article_id, actual_datetime);
                console.log(e, 'eeeeee')
                if (e.article_name && qty && no_of_trays) {
                    let text = e.article_name +  ' required quantity ' + qty + ' and number of trays ' + no_of_trays;
                    speech(text);
                }
            });

            // function speech(text) {
            //     var msg = new SpeechSynthesisUtterance();
            //     msg.text = text;

            //     // Increment the speech counter when a new speech is initiated
            //     speechCounter++;

            //     msg.onend = function (event) {
            //         // Decrement the counter when a speech ends
            //         speechCounter--;

            //         // Check if all speeches have finished playing
            //         if (speechCounter === 0) {
            //             // All speeches have finished playing
            //             this.is_speech_playing = false;
            //         }
            //     }.bind(this); // Ensure the correct context of 'this'

            //     window.speechSynthesis.speak(msg);
            // }
        },
        saveSetupRecord(item_index) {
            this.productionSetupData.forEach((e, i) => {
                if (e.is_editable) {
                    this.setup_tbl_loading = true;
                    api.saveStoreProdSetup({
                        "id": e.id,
                        "production_station_id": e.production_station_id.toString(),
                        "article_id": e.article_id,
                        "holding_time": moment(e.time).format('HH:mm') + ':00',
                        "max_quantity_per_tray": e.max_quantity_per_tray,
                        "number_of_slots": e.number_of_slots
                    }).then(response => {
                        if (response.status == 200) {
                            this.productionSetupData[item_index].is_editable = false;
                            this.$notify.success({
                                title: 'Success',
                                message: 'Production setup updated successfully'
                            });
                            this.getStoreProductionSetup();
                            this.setup_tbl_loading = false;
                        }
                    }).catch(err => {
                        this.setup_tbl_loading = false;
                        console.log(err);
                        this.$notify.error({
                            title: 'Error',
                            message: 'Oops something went wrong'
                        })
                    });
                }
            });
        },
        deleteSetupRecord(id) {
            this.setup_tbl_loading = true;
            this.$confirm('Are you sure to delete this record?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                api.deleteStoreProdSetup({ id: id })
                    .then(response => {
                        if (response.status == 200) {
                            this.$notify.success({
                                title: 'Success',
                                message: 'Production setup deleted successfully'
                            });
                            this.getStoreProductionSetup();
                            this.setup_tbl_loading = false;
                        }
                    }).catch(err => {
                        this.setup_tbl_loading = false;
                        console.log(err);
                        this.$notify.error({
                            title: 'Error',
                            message: 'Oops something went wrong'
                        })
                    });
            }).catch(() => {
                this.setup_tbl_loading = false;
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                });
            });
        },
        editAction(item_index, id) {
            // this.old_setup_record = JSON.parse(JSON.stringify(this.productionSetupData[item_index]));
            // this.productionSetupData.forEach((e, i) => {
            //     if (i != item_index) {
            //         e.is_editable = false;
            //         e =  this.store_production_setup_data.find(e => e.id == id);
            //     }
            // });
            this.productionSetupData[item_index].is_editable = true;
            this.$forceUpdate();
        },
        revertOldRecord(id, item_index) {
            console.log(id, item_index, 'id, item_index')
            const old_data = this.store_production_setup_data.find(e => e.id == id);
            this.productionSetupData[item_index].holding_time = moment(old_data.holding_time, 'HH:mm:ss').format("HH:mm");
            this.productionSetupData[item_index].time = moment(old_data.holding_time, 'HH:mm:ss').format();
            this.productionSetupData[item_index].number_of_slots = old_data.number_of_slots;
            this.productionSetupData[item_index].is_editable = false;
            this.$forceUpdate();
        },
        updateArticle(item_index, id) {
            this.productionSetupData[item_index].article_id = id;
            this.$forceUpdate();
        },
        updateStation(item_index, id) {
            this.productionSetupData[item_index].production_station_id = id;
        },
        handleStationChange() {
            const station = this.production_stations.find(s => s.production_station_id == this.production_station_id);
            console.log(station, 'station')
            this.number_of_stations = station ? station.number_of_stations : null;
            this.is_station_active = station ? station.active : true;
            this.$forceUpdate();
        },
        updateTime(item_index, time) {
            this.$set(this.productionSetupData[item_index], 'time', time);
            this.$set(this.productionSetupData[item_index], 'holding_time', moment(time).format('HH:mm:ss'));
            // this.productionSetupData[item_index].holding_time = moment(time).format('HH:mm');
            // this.$nextTick(() => {
            //     this.productionSetupData[item_index].time = moment(time).format('HH:mm');
            //     this.productionSetupData[item_index].rrrr = moment(time).format();
            //     this.productionSetupData[item_index].aaaa = '----';
            //     this.$forceUpdate();
            // });
            // this.productionSetupData[item_index].rrrr = moment(time).format();
            this.$forceUpdate();
        },
        selectLocation() {
            this.forecast_tbl_loading = true;
            localStorage.setItem('production_selected_store', this.selected_location);
            localStorage.setItem('production_selected_date', this.selected_date);
            this.getStoreProductionSetup();
            this.getArticles();
            this.getProdStationList();
            this.getStationList();
            // this.getForecastQtyData();
            // this.getVcmsForecastData();
        },
        changeDate() {
            this.forecast_tbl_loading = true;
            localStorage.setItem('production_selected_date', this.selected_date);
            this.getForecastQtyData();
            this.getVcmsForecastData();
        },
        changeStation() {
            this.forecast_tbl_loading = true;
            localStorage.setItem('production_selected_date', this.selected_date);
            this.getForecastQtyData();
            this.getVcmsForecastData();
        },
        getLocationList() {
            this.forecast_tbl_loading = true;
            api.getAllStoreData()
                .then(response => {
                    if (response.status == 200) {
                        let all_location_list = JSON.parse(response.data);

                        if (all_location_list.length) {
                            this.location_list = all_location_list.filter(e => {
                                if (e.type == "store") {
                                    return e;
                                }
                            });

                            let checkLocalStorage = localStorage.getItem('production_selected_store');
                            if (checkLocalStorage) {
                                this.selected_location = localStorage.getItem('production_selected_store');
                            } else {
                                this.selected_location = this.location_list[0].id;
                                localStorage.setItem('production_selected_store', this.selected_location);
                            }

                            let checkLocalStorageDate = localStorage.getItem('production_selected_date');
                            if (checkLocalStorageDate) {
                                this.selected_date = localStorage.getItem('production_selected_date');
                            } else {
                                this.selected_date = moment().format('YYYY-MM-DD');
                                localStorage.setItem('production_selected_date', this.selected_date);
                            }

                            this.selectLocation();
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getStoreProductionSetup() {
            this.setup_tbl_loading = true;
            api.getStoreProdSetup({ outlet_id: this.selected_location })
                .then(response => {
                    if (response.status == 200) {
                        this.store_production_setup_data = JSON.parse(response.data);
                    }
                    this.setup_tbl_loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.setup_tbl_loading = false;
                });
        },
        saveNewStation() {
            const payload = { 
                name: this.new_station_name,
                active: this.is_station_active,
                outlet_id: this.selected_location,
                number_of_stations: this.number_of_stations,
                production_station_id: this.production_station_id,
            }
            this.$validator.validateAll(['Select Production Station 2', 'Number of station', 'New Station Name']).then((result) => {
                if(result){
                    this.station_loading = true;
                    api.saveNewStation(payload)
                    .then(response => {
                        this.getStationList();
                        this.station_loading = false;
                        this.add_prod_station_popup = false;
                        this.new_station_name = '';
                        this.$notify.success({
                            title: "Success",
                            message: "New station added successfully"
                        })
                    })
                    .catch(err => {
                        console.log(err);
                        this.station_loading = false;
                    });
                }
            });
        },
        getArticles() {
            api.getArticlesForOutlet({ outlet_id: this.selected_location })
                .then(response => {
                    if (response.status == 200) {
                        this.store_articles = JSON.parse(response.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getForecastQtyData() {
            api.getVcmsForecastQtyData({ outlet_id: this.selected_location, date: moment(this.selected_date).format('YYYY-MM-DD'), production_station_id: this.selected_production })
                .then(response => {
                    if (response.status == 200) {
                        this.forecast_qty_data = JSON.parse(response.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getStationList() {
            api.getStoreProdStation({ outlet_id: this.selected_location })
                .then(response => {
                    if (response.status == 200) {
                        this.production_stations = JSON.parse(response.data);
                    }
                    this.selected_production_station = this.production_stations.length ? this.production_stations[0].id : '';
                    this.selected_production = this.production_stations.length ? this.production_stations[0].id : '';
                    // this.handleClose();
                    this.getVcmsForecastData();
                    this.getForecastQtyData();
                })
                .catch(err => {
                    console.log(err);
                });
        },
       async generatePLSPdf(){
        const doc = new jsPDF('landscape');

        // Use autoTable with configuration options
        doc.autoTable({
            html: '#productionTable',
            startY: 10, // starting position on the y-axis
            styles: {
                overflow: 'linebreak', // handle overflowing text
                cellWidth: 'wrap', // wrap cell content if too wide
                fontSize: 10 // adjust font size for readability
            },
            columnStyles: {
                0: { cellWidth: 'auto' }, // first column
                // Add more columns if needed and set widths accordingly
            },
            didDrawCell: (data) => {
                if (data.section === 'body' && data.row.index === data.table.body.length - 1) {
                    doc.addPage();
                }
            }
        });
    
        doc.save('production_table.pdf');
        },
        getProdStationList() {
            api.getProdStation({ outlet_id: this.selected_location })
                .then(response => {
                    if (response.status == 200) {
                        this.production_station_list = JSON.parse(response.data);
                    }
                    this.production_station_id = this.production_station_list[0].id;
                    // this.handleClose();
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getProdSegments() {
            api.getProdSegment()
                .then(response => {
                    if (response.status == 200) {
                        this.production_segments = JSON.parse(response.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        handleClose() {
            this.$validator.reset();
            this.add_new_prod_setup = false;
            this.add_prod_station_popup = false;
        },
        addNewStoreSetup() {
            console.log(this.selected_article_id);
            this.$validator.validateAll(["Select Production Station", "New Station Name", "Select article", "Select Holding Time"]).then((result) => {
                console.log(result);
                if (result) {
                    this.$validator.reset();
                    this.add_new_prod_setup = false;
                    api.saveStoreProdSetup({
                        "production_station_id": this.selected_production_station.toString(),
                        "article_id": this.selected_article_id,
                        "holding_time": moment(this.selected_holding_time).format('HH:mm') + ':00',
                        "max_quantity_per_tray": this.selected_tray,
                        "number_of_slots": this.selected_slots
                    }).then(response => {
                        if (response.status == 200) {
                            this.$notify.success({
                                title: 'Success',
                                message: 'Production setup added successfully'
                            });
                            this.getStoreProductionSetup();
                        }
                    }).catch(err => {
                        console.log(err);
                        this.$notify.error({
                            title: 'Error',
                            message: 'Oops something went wrong'
                        })
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: 'Please fill all required fields'
                    });
                }
            });
        },
        getVcmsForecastData(speech) {
            this.forecast_tbl_loading = true;
            if (this.selected_location && this.selected_date) {
            } else {
                this.$notify.error({
                    title: 'Error',
                    message: 'Please select store and date'
                });
                return;
            }
            api.getVcmsForecastData({ outlet_id: this.selected_location, date: moment(this.selected_date).format('YYYY-MM-DD'), production_station_id:this.selected_production })
                .then(response => {
                    if (response.status == 200) {
                        let data = JSON.parse(response.data);

                        // Remove data with article_id null
                        data = data.filter(e => e.article_id != null);
                        // Setup Data
                        if (data.length) {
                            this.all_query_data = data;
                            let prod_header = [...data];
                            let prod_data = [...data];
                            // Get only unique data from prod_header according to actual_datetime
                            prod_header = prod_header.filter((thing, index, self) =>
                                index === self.findIndex((t) => (
                                    t.actual_datetime === thing.actual_datetime
                                ))
                            );
                            this.formatProductionData(prod_header, prod_data, speech);
                        } else {
                            this.forecast_tbl_loading = false;
                            this.production_header = [];
                            this.production_data = [];
                        }
                    }
                })
                .catch(err => {
                    this.forecast_tbl_loading = false;
                    console.log(err);
                });
        },
        scrollToCurrentTimeData() {
            // Scrolling effect

            // Get current time in hours and minutes
            const currentTime = new Date();
            const currentHours = currentTime.getHours();
            const currentMinutes = currentTime.getMinutes();

            // Round the minutes to the nearest half-hour mark
            let roundedMinutes;
            if (currentMinutes < 30) {
                roundedMinutes = 0;
            } else {
                roundedMinutes = '00';
            }

            // Calculate the rounded time in HH:mm format
            const formattedTime = ('0' + currentHours).slice(-2) + ':' + ('0' + roundedMinutes).slice(-2);

            // Find the cell corresponding to the current rounded time (nearest hour or half-hour)
            const cellId = 'head-th-cell-' + formattedTime;
            const targetCell = document.getElementById(cellId);

            if (targetCell) {
                // Scroll horizontally to bring the cell into view
                const table = document.querySelector('.ns-production-table');
                table.scrollLeft = targetCell.offsetLeft - table.getBoundingClientRect().left;
                targetCell.scrollIntoView({ behavior: "smooth", block: "end", inline: "center" });
                // Highlight the cell for 2 seconds
                targetCell.classList.add('highlighted');
                setTimeout(() => {
                    targetCell.classList.remove('highlighted');
                }, 1000); // 2000 milliseconds = 2 seconds
            }
        },
        formatProductionData(prod_header, prod_data, speech) {
            let temp = [];
            prod_header.forEach((e, i) => {
                let temp_obj = {};
                temp_obj.actual_datetime = e.actual_datetime;
                temp_obj.time = moment(e.actual_datetime).format('HH:mm');
                temp_obj.level = this.getLevelName(e.production_segment_id);
                temp_obj.transaction = e.transactions;
                temp_obj.bg_color = e.production_segment_id == 3 ? '#026906' : e.production_segment_id == 5 ? '#d17d4d' : e.production_segment_id == 6 ? '#b53109' : e.production_segment_id == 4 ? '#0a0403' : '#c2c0c0';
                // Check is the time is between day_parts_data time or not then assign that day_parts_data name to e.day_part
                this.day_parts_data.forEach((d, i) => {
                    let date = moment(this.selected_date).format('YYYY-MM-DD');
                    d.formatted_start_time = d.start_time ? date + 'T' + d.start_time + ':00' : '';
                    d.formatted_end_time = d.end_time ? date + 'T' + d.end_time + ':00' : '';
                    if(d.start_time == '23:00') {
                        d.formatted_end_time =  d.end_time ? moment(this.selected_date).add(1, 'days').format('YYYY-MM-DD') + 'T' + d.end_time + ':00' : '';
                    }
                });
                const inputTime = moment(temp_obj.actual_datetime, 'YYYY-MM-DDTHH:mm:ss');
                const day_part = this.day_parts_data.find(d => {
                    let start_time = moment(d.formatted_start_time, 'YYYY-MM-DDTHH:mm:ss');
                    let end_time = moment(d.formatted_end_time, 'YYYY-MM-DDTHH:mm:ss');
                    return inputTime.isBetween(start_time, end_time, null, '[]');
                });
                temp_obj.day_part = day_part ? day_part.day_part_name : '-';
                temp_obj.day_part_color = day_part ? day_part.day_part_color : '-';
                temp_obj.day_part_id = day_part ? day_part.id : '-';
                temp.push(temp_obj);
            });
            // Now group all prod_data data according to article_id
            const groupedData = _.chain(prod_data)
                .groupBy('article_id')
                .map((group, article_id) => {
                    return {
                        article_id,
                        transactions: _.reduce(group, (memo, item) => memo + item.transactions, 0),
                        quantity: _.reduce(group, (memo, item) => memo + item.quantity, 0),
                        date: _.reduce(group, (memo, item) => item.actual_datetime, 0),
                        actual_datetime: _.reduce(group, (memo, item) => item.actual_datetime, 0),
                        production_segment_id: _.reduce(group, (memo, item) => item.production_segment_id, 0),
                        stock_level: _.reduce(group, (memo, item) => item.stock_level, 0),
                        article_name: _.reduce(group, (memo, item) => item.article_name, 0),
                        number_of_slots: '-',
                        max_quantity_per_tray: '-',
                    };
                })
                .value();
            // Now sort the grouped data according to actual_datetime and add article name in it using getArtcileName function
            groupedData.forEach((e, i) => {
                const prod_setup_data = this.store_production_setup_data.find(s => s.article_id == e.article_id);
                const prod_qty_data = this.forecast_qty_data.find(s => s.article_id == e.article_id);
                // e.article_name = prod_setup_data ? prod_setup_data.article_name : '-';
                // e.article_name = this.getArticleName(e.article_id);
                e.holding_time = prod_setup_data ? moment(prod_setup_data.holding_time, 'HH:mm:ss').format('HH:mm') : '-';
                e.number_of_slots = prod_setup_data ? prod_setup_data.number_of_slots : '-';
                e.max_quantity_per_tray = prod_setup_data ? prod_setup_data.max_quantity_per_tray : '-';
                e.item_qty = prod_qty_data ? prod_qty_data.quantity : '-';
            });
            groupedData.sort((a, b) => {
                return new Date(a.actual_datetime) - new Date(b.actual_datetime);
            });
            //  Remove data if article_id is null
            // groupedData = groupedData.filter(e => e.article_id != null);
            // Show the grouped data
            // console.log(groupedData, 'groupedData');
            this.production_header = temp;
            this.production_data = groupedData;
            this.forecast_tbl_loading = false;

            setTimeout(() => {
                this.scrollToCurrentTimeData();
            }, 1000);

            const self = this;
            if(speech){
                // console.log(speech, 'speech')
                setTimeout(() => {
                    if(speech.check === 'call_speech_data'){
                        const actual_datetime = moment(self.selected_date).format('YYYY-MM-DD') + 'T' + moment(speech.time).format('HH:mm:ss');
                        console.log(actual_datetime, 'actual_datetime -')
                        self.speechProductInfo(actual_datetime);
                    }
                }, 1500);
            }
        },
        getLevelName(id) {
            const level = this.production_segments.find(e => e.id == id);
            return level ? level.name : '-';
        },
        getProdSetupDataByDateKey(key, id, date_time) {
            let result = '';
            this.all_query_data.forEach(e => {
                if (e.article_id == id && e.actual_datetime == date_time) {
                    result = e[key];
                }
            });
            return result ? result : 0;
        },
        getArticleName(id) {
            const article = this.store_articles.find(e => e.id == id);
            // console.log(article, id ,'article')
            return article ? article.name : '-';
        },
        clickOnAddNew() {
            // Reset all fields
            this.selected_article_id = '';
            this.selected_holding_time = '';
            this.selected_tray = '';
            this.selected_slots = '';
            this.$validator.reset();
            this.add_new_prod_setup = true;
        },
        clickOnAddNewStation(){
            this.number_of_stations = null;
            this.production_station_id = null;
            this.$validator.reset();
            this.add_prod_station_popup = true;
        }
    },
};